import { useEffect, useState } from 'react';
import { api } from '../../lib/api';

type Props = {
  onToast: (msg: string, kind?: 'ok' | 'err') => void;
  onError: (e: unknown) => void;
};

type Series = {
  id: string;
  code: string;
  fiscalYear: number;
  nextNumber: number;
  format: string;
  active: boolean;
};

export function Serie({ onToast, onError }: Props) {
  const [items, setItems] = useState<Series[]>([]);
  const [showCreate, setShowCreate] = useState(false);

  async function load() {
    try {
      const r = await api<{ items: Series[] }>('/admin/series');
      setItems(r.items);
    } catch (e) {
      onError(e);
    }
  }
  useEffect(() => {
    void load();
  }, []);

  async function activate(id: string) {
    try {
      await api(`/admin/series/${id}/activate`, { method: 'POST' });
      onToast('Serie activada', 'ok');
      void load();
    } catch (e) {
      onError(e);
    }
  }

  return (
    <div className="adm-section">
      <div className="stitle">Serie de numeración</div>
      <h2 style={{ display: 'flex', alignItems: 'baseline' }}>
        Series
        <button className="btn primary" style={{ marginLeft: 'auto' }} onClick={() => setShowCreate(true)}>
          <span className="plus">+</span> Nueva serie
        </button>
      </h2>
      <div className="card">
        <table className="t">
          <thead>
            <tr>
              <th>Code</th>
              <th>Ejercicio</th>
              <th>Próximo nº</th>
              <th>Formato</th>
              <th>Estado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.id}>
                <td className="mono">{s.code}</td>
                <td className="mono">{s.fiscalYear}</td>
                <td className="num">{s.nextNumber}</td>
                <td className="mono">{s.format}</td>
                <td>
                  {s.active ? (
                    <span className="pill ok">ACTIVA</span>
                  ) : (
                    <span className="pill draft">INACTIVA</span>
                  )}
                </td>
                <td>
                  {!s.active && <button className="btn sm" onClick={() => activate(s.id)}>activar</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showCreate && (
        <CreateSeriesModal
          onClose={() => setShowCreate(false)}
          onCreated={() => {
            setShowCreate(false);
            void load();
            onToast('Serie creada', 'ok');
          }}
          onError={onError}
        />
      )}
    </div>
  );
}

function CreateSeriesModal(props: {
  onClose: () => void;
  onCreated: () => void;
  onError: (e: unknown) => void;
}) {
  const [code, setCode] = useState('A');
  const [year, setYear] = useState(new Date().getFullYear());
  const [start, setStart] = useState(1);
  const [format, setFormat] = useState('YEAR-NNNN');
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api('/admin/series', {
        method: 'POST',
        body: { code: code.toUpperCase(), fiscalYear: year, startingNumber: start, format },
      });
      props.onCreated();
    } catch (e) {
      props.onError(e);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="modal-backdrop" onClick={props.onClose}>
      <form className="modal" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <h3>Nueva serie</h3>
        <div className="field"><label>Code</label><input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} maxLength={4} required /></div>
        <div className="field"><label>Ejercicio</label><input type="number" value={year} onChange={(e) => setYear(Number.parseInt(e.target.value, 10))} required /></div>
        <div className="field"><label>Primer número</label><input type="number" value={start} onChange={(e) => setStart(Number.parseInt(e.target.value, 10))} required /></div>
        <div className="field">
          <label>Formato</label>
          <input value={format} onChange={(e) => setFormat(e.target.value)} required />
          <div className="hint">YEAR-NNNN → 2026-0114</div>
        </div>
        <div className="actions">
          <button type="button" className="btn ghost" onClick={props.onClose}>Cancelar</button>
          <button type="submit" className="btn primary" disabled={busy}>Crear</button>
        </div>
      </form>
    </div>
  );
}
